import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatErr } from "@/lib/api";

export default function Login() {
  const { user, login, loginWithGoogle, loading } = useAuth();
  const [email, setEmail] = useState("admin@shreeram.com");
  const [password, setPassword] = useState("admin123");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (loading) return null;
  if (user) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/");
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-background">
      {/* Left */}
      <div className="hidden lg:block relative w-1/2">
        <img
          src="https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="Warehouse"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[hsl(222.2_47.4%_11.2%)]/70" />
        <div className="relative h-full flex flex-col justify-end p-12 text-white">
          <img src="/logo.png"
               alt="Shree Ram Enterprises"
               className="w-16 h-16 rounded-full object-cover mb-6 bg-white p-1" />
          <h1 className="font-display text-4xl xl:text-5xl font-bold leading-tight">Shree Ram Enterprises</h1>
          <p className="text-white/70 mt-3 max-w-md">
            Authorized service provider for Hindware, Livpure, Croma & more. Track parts, technicians, sales &
            service jobs — all in one place.
          </p>
        </div>
      </div>

      {/* Right */}
      <div className="flex-1 flex items-center justify-center p-6">
        <form onSubmit={onSubmit} className="w-full max-w-sm space-y-6" data-testid="login-form">
          <div>
            <img src="/logo.png"
                 alt="Shree Ram Enterprises"
                 className="lg:hidden w-14 h-14 rounded-full object-cover mb-4 bg-white p-0.5" />
            <h2 className="font-display text-3xl font-bold">Sign in</h2>
            <p className="text-sm text-muted-foreground mt-1">Enter your credentials to access the ERP.</p>
          </div>
          <div className="space-y-3">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" data-testid="login-email-input" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" data-testid="login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
          </div>
          <Button type="submit" disabled={busy} data-testid="login-submit-button" className="w-full h-11">
            {busy ? "Signing in..." : "Sign in"}
          </Button>

          <div className="relative">
            <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-border"></div></div>
            <div className="relative flex justify-center text-xs uppercase"><span className="bg-background px-2 text-muted-foreground">OR</span></div>
          </div>

          <button type="button" onClick={loginWithGoogle} data-testid="login-google-button"
            className="w-full h-11 border border-border rounded-md flex items-center justify-center gap-3 hover:bg-secondary/50 text-sm font-semibold transition-colors">
            <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path fill="#4285f4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.44c-.29 1.48-1.14 2.73-2.4 3.58v3h3.86c2.26-2.09 3.59-5.17 3.59-8.82z"/>
              <path fill="#34a853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09C3.26 21.3 7.31 24 12 24z"/>
              <path fill="#fbbc05" d="M5.27 14.29c-.25-.72-.38-1.49-.38-2.29s.14-1.57.38-2.29V6.62H1.29A11.99 11.99 0 0 0 0 12c0 1.93.46 3.76 1.29 5.38l3.98-3.09z"/>
              <path fill="#ea4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.7 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z"/>
            </svg>
            Continue with Google
          </button>

          <p className="text-xs text-muted-foreground text-center">
            Default admin: <b>admin@shreeram.com</b> / <b>admin123</b>
          </p>
        </form>
      </div>
    </div>
  );
}
